import {
  USER_IMPERSONATE,
  PREVIEWS_CAS_DETAILS,
  USER_IMPERSONATE_LOADING,
  USER_IMPERSONATE_LOADED,
  USER_IMPERSONATE_RESET,
  USER_IMPERSONATE_END,
} from '../../actionTypes/Users/UserActionType';

const initialUserImpersonateState = {
  loading: false,
  impersonate: {
    guid: '',
    err: '',
    session: null,
    userPersonated: null,
  },
  previousCasDetails: {
    casDetails: null,
    casOrgs: [],
    reportMenus: null,
  },
};

export default function impersonateReducer(state = initialUserImpersonateState, action) {
  switch (action.type) {
    case USER_IMPERSONATE:
      return { ...state, loading: false, impersonate: { ...state.impersonate, ...action.payload }, };
    case USER_IMPERSONATE_END:
      return { ...state, loading: false, impersonate: { ...state.impersonate, ...action.payload, userPersonated: null, }, };
    case USER_IMPERSONATE_LOADING:
      return { ...state, loading: true, };
    case USER_IMPERSONATE_LOADED:
      return { ...state, loading: false, };
    case PREVIEWS_CAS_DETAILS:
      return { ...state, previousCasDetails: action.payload, };
    case USER_IMPERSONATE_RESET:
      return { ...state, ...initialUserImpersonateState, };
    default:
      return state;
  }
}
